import BEM from '../bem';
import AvatarImage from './AvatarImage';

const classes = BEM.with('AvatarImage');

const MODIFIERS_WITH_INITIALS = { initials: true };

type SCImGroupAvatarProps = {
  className: string;
  scim: {
    displayName: string;
  };
  size: number;
  entityType: string;
};

function getInitials(displayName: string) {
  return displayName
    .split(' ')
    .map((name) => name[0])
    .join('');
}

function SCIMGroupAvatar({ className, scim, size, entityType }: SCImGroupAvatarProps) {
  const fontSize = size < 50 ? Math.round(size * 0.47) : 24;

  const initials = getInitials(scim.displayName);
  const initialsFontSizeStyles = fontSize ? { fontSize } : {};

  return (
    <AvatarImage
      className={className}
      displayName={scim.displayName}
      entityType={entityType}
      modifiers={MODIFIERS_WITH_INITIALS}
      size={30}
    >
      <span style={initialsFontSizeStyles} className={classes('initials', { entityType })}>
        {initials}
      </span>
    </AvatarImage>
  );
}

export default SCIMGroupAvatar;
